type Browser = "Chrome" | "Edge" | "Brave" | "Opera" | "Firefox" | "Safari" | "Unknown";

export class JobArrangerBrowsers
{
    static browsers: Record<Browser, string | null> = {
        Chrome: "https://chromewebstore.google.com/detail/job-arranger-linkedininde/paihdpncghiaifanpfaddgaphjdaijbo?hl=en&authuser=0",
        Edge: "https://microsoftedge.microsoft.com/addons/detail/laljmdcjpkoclppboohlkplnkgeiagfc",
        Brave: "https://chromewebstore.google.com/detail/job-arranger-linkedininde/paihdpncghiaifanpfaddgaphjdaijbo?hl=en&authuser=0",
        Firefox: "https://addons.mozilla.org/en-US/firefox/addon/job-arranger/",
        Opera: null,
        Safari: null,
        Unknown: null,
    }

    private static detect(): Browser
    {
        const ua = navigator.userAgent;

        if (ua.includes("Edg/"))
            return "Edge";
        if ((navigator as any).brave?.isBrave)
            return "Brave";
        if (ua.includes("OPR/") || ua.includes("Opera/"))
            return "Opera";
        if (ua.includes("Firefox/"))
            return "Firefox";
        if (ua.includes("Safari/") && !ua.includes("Chrome/"))
            return "Safari";
        if (ua.includes("Chrome/"))
            return "Chrome";

        return "Unknown";
    }

    static getExtensionLink(): string | null
    {
        const browser = this.detect();
        return JobArrangerBrowsers.browsers[browser];
    }
}